module.exports = __webpack_public_path__ + "static/media/personal-link-bg.dbc9d004.svg";